// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Hidable from "../../components/Hidable"
import BigList from "../../components/BigList"
import Button from "react-toolbox/lib/button"
import DebtSummaryHeader from "../../components/DebtSummaryHeader"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  getDebtById, getDebtDebtors, updateDebtorContact,
  addDebtor, removeDebtor, updateContactHistory,
  newContact, getContactHistorybyDebtId, updateDebt,
  removeContactHistory,
} from "../../actions"
import LabeledValue from "../../components/LabeledValue"
import { formatCurrency, removeNulls } from "../../utils"
import DebtPaymentAgreements from "../../components/DebtPaymentAgreements"
import * as strings from "../../strings"
import DebtPhaseDebtors from "../../components/DebtPhaseDebtors"
import DebtPhaseContactHistory from "../../components/DebtPhaseContactHistory"
import SaveButton from "../../components/SaveButton"
import Card from "../../components/Card"
import Division from "../../components/Division"
import _ from "lodash"
import { toastr } from "react-redux-toastr"

const errorTab = <div className={style.errorTab}>{strings.generalStrings.noResults}</div>

class DebtView extends Component {

  props: {
    newContact: any,
    updateContactHistory: any,
    removeContactHistory: any,
    getDebt: any,
    getDebtById: any,
    updateDebtorContact: any,
    addDebtor: any,
    history: any,
    auth: {
      token: string,
    },
    match: {
      path: string,
      params: {
        debtId: string,
      },
    },
  }

  state = {
    contactHistories: [],
    showContactHistory: false,
    showDebtors: false,
    showPaymentAgreements: false,
    showPreLitigation: false,
    showLitigation: false,
    showExecution: false,
    allPaymentAgreements: undefined,
    preLitigation: undefined,
    debtorsInfo: undefined,
    debtorsToDelete: [],
  }

  componentWillMount = () => {
    this.props.getDebtById( parseInt( this.props.match.params.debtId, 10 ) )
      .then( () => {
        this.fetchDebtors( this.props.getDebt.id )
        this.setState( {
          contactHistories: this.props.getDebt.contactHistories,
        } )
      } )
  }

  showDebtors = () => {
    this.setState( {
      showDebtors: !this.state.showDebtors,
    } )
  }

  showPaymentAgreements = () => {
    this.setState( {
      showPaymentAgreements: !this.state.showPaymentAgreements,
    } )
  }
  showContactHistory = () => {
    this.setState( {
      showContactHistory: !this.state.showContactHistory,
    } )
  }

  showPreLitigation = () => {
    this.setState( {
      showPreLitigation: !this.state.showPreLitigation,
    } )
  }

  showLitigation = () => {
    this.setState( {
      showLitigation: !this.state.showLitigation,
    } )
  }

  showExecution = () => {
    this.setState( {
      showExecution: !this.state.showExecution,
    } )
  }

  getDebtPhase = () => {
    if ( this.props.getDebt.length === 0 ) {
      return undefined
    }

    if ( this.props.getDebt.executions.length !== 0 ) {
      return strings.processes.execution.toUpperCase()
    } else if ( this.props.getDebt.litigations.length !== 0 ) {
      return strings.processes.litigation.toUpperCase()
    } else {
      return strings.processes.preLitigation.toUpperCase()
    }
  }

  renderDebtDetails = () => {
    const debt = this.props.getDebt
    const mainDebtor = _.get( debt, "debtDebtors", [] )
      .find( debtor => debtor.debtor.id === debt.idDebtor ).debtor

    const { generalStrings } = strings
    return (
      <div className={style.rowIslands}>
        <Card decor style={{ flex: "6" }}>
          <div className={style.leftIslandInfo}>
            <Division title={generalStrings.information.toUpperCase()} />
            <div className={style.leftIslandBody}>
              <div className={style.wrapper}>
                <LabeledValue big label={strings.debtor.title}>
                  {( mainDebtor && mainDebtor.contact.name ) || generalStrings.emptyField}
                </LabeledValue>
                <LabeledValue big label={strings.debtor.debtorNif}>
                  {( mainDebtor && mainDebtor.contact.nif ) || generalStrings.emptyField}
                </LabeledValue>
                <LabeledValue big label={strings.generalStrings.client}>
                  {( debt && debt.client && debt.client.contact.name ) || generalStrings.emptyField}
                </LabeledValue>
                <LabeledValue big label={generalStrings.privateLawyersId}>
                  {( debt && debt.plid ) || generalStrings.emptyField}
                </LabeledValue>
                <LabeledValue big label={generalStrings.lawyer}>
                  {( debt && debt.lawyer && debt.lawyer.contact.name ) || generalStrings.emptyField}
                </LabeledValue>
                <LabeledValue big label={strings.paymentAgreements.totalValue}>
                  {( debt && formatCurrency( debt.totalValue ) ) || generalStrings.emptyField}
                </LabeledValue>
              </div>
            </div>
          </div>
        </Card>
      </div>
    )
  }

  renderPreLitigation = () => {
    const { generalStrings } = strings
    const userColumns = [
      { title: generalStrings.privateLawyersId, key: "plid" },
      { title: generalStrings.idc, key: "idc" },
      { title: generalStrings.type, key: "type" },
      { title: generalStrings.subType, key: "subType" },
      { title: generalStrings.state, key: "state" },
    ]

    const preLitigationProcedures = this.props.getDebt.preLitigations || []
    const items = preLitigationProcedures.map( preLitigation => ( {
      idc: preLitigation.idc || "--",
      plid: preLitigation.plid || "--",
      type: _.get( preLitigation, "activeOption.type.name", "--" ),
      subType: _.get( preLitigation, "activeOption.subtype.name", "--" ),
      state: _.get( preLitigation, "activeOption.state.name", "--" ),
      _onClick: () => this.props.history.push( "/preLitigation/" + preLitigation.id ),
    } ) )

    return <div className={this.state.showPreLitigation ? style.showContent : style.hiddenContent}>
      {preLitigationProcedures.length !== 0 ? this.renderBigList( items, userColumns ) : errorTab}
    </div>
  }

  isLinked = ( litigation ) => {
    const debt = this.props.getDebt
    if ( ( _.isEqual( litigation.litigationExecutions.length, 0 ) ) ) {
      return true
    } else {
      const isActive = litigation.litigationExecutions.map( litigationExecution => {
        const execution = debt.executions.find( execution => _.isEqual( execution.id, litigationExecution.idExecution ) )
        return execution.isActive
      } )
      return !( _.compact( isActive ).length > 0 )
    }
  }

  renderLitigation = () => {
    const { generalStrings } = strings
    const userColumns = [
      { title: generalStrings.idc, key: "idc" },
      { title: generalStrings.type, key: "type" },
      { title: generalStrings.subType, key: "subType" },
      { title: generalStrings.state, key: "state" },
    ]

    const litigationProcedures = this.props.getDebt.litigations || []
    const filteredLitigationProcedures = litigationProcedures.filter( litigation => this.isLinked( litigation ) )
    const items = filteredLitigationProcedures.map( litigation => ( {
      idc: litigation.idc || "--",
      type: _.get( litigation, "activeOption.type.name", "--" ),
      subType: _.get( litigation, "activeOption.subtype.name", "--" ),
      state: _.get( litigation, "activeOption.state.name", "--" ),
      _onClick: () => this.props.history.push( "/litigation/" + litigation.id ),
    } ) )

    return (
      <div className={this.state.showLitigation ? style.showContent : style.hiddenContent}>
        {filteredLitigationProcedures.length !== 0 ? this.renderBigList( items, userColumns ) : errorTab}
      </div>
    )
  }

  renderExecution = () => {
    const { generalStrings } = strings
    const userColumns = [
      { title: generalStrings.active, key: "active" },
      { title: strings.paymentAgreements.executionNumber, key: "executionNumber" },
      { title: generalStrings.type, key: "type" },
      { title: generalStrings.subType, key: "subType" },
      { title: generalStrings.state, key: "state" },
    ]

    const executionProcedures = this.props.getDebt.executions || []
    const items = executionProcedures.map( execution => {
      return {
        executionNumber: execution.executionNumber || "--",
        type: _.get( execution, "option.type.name", "--" ),
        subType: _.get( execution, "option.subtype.name", "--" ),
        state: _.get( execution, "option.state.name", "--" ),
        active: <div className={execution.isActive ? style.activeCircle : style.inactiveCircle}></div>,
        _onClick: () => this.props.history.push( "/execution/" + execution.id ),
      }
    } )

    return (
      <div className={this.state.showExecution ? style.showContent : style.hiddenContent}>
        {executionProcedures.length !== 0 ? this.renderBigList( items, userColumns ) : errorTab}
      </div>
    )
  }
  
  renderTab = ( componentToRender, title, onToggle, expanded, titleNumber ) => {
    return (
      <Hidable
        title={title}
        onToggle={onToggle}
        expanded={expanded}
        titleNumber={titleNumber}
      >
        {componentToRender()}
      </Hidable>
    )
  }

  renderBigList = ( items, columns ) => {
    return <BigList
      loadMore={() => { }}
      hasMoreItems={() => false}
      items={items}
      columns={columns}
    />
  }

  renderPaymentAgreements = () => {
    const button = (
      <div className={style.buttonContainer}>
        <Button onClick={() => this.props.history.push( "/CreatePaymentAgreement/" + this.props.getDebt.id ) }
          icon="add" raised primary>{strings.generalStrings.add}</Button>
      </div>
    )

    return (
      <div className={this.state.showPaymentAgreements ? style.showContent : style.hiddenContent}>
        {
          ( this.props.getDebt.paymentAgreements.length !== 0 ) ?
            <DebtPaymentAgreements
              idDebt={this.props.getDebt.id}
              paymentAgreements={this.props.getDebt.paymentAgreements}
              expanded={false}
            /> :
            <div style={{ marginBottom: "0px" }} className={style.errorTab}>{strings.generalStrings.noResults}</div>
        }
        { button }
      </div>
    )
  }

  getPaymentAgreements = ( phases ) => ( phases || [] ).map( phase => phase.paymentAgreements )

  sortPaymentAgreements = ( paymentAgreements ) => {
    return paymentAgreements.sort( ( a, b ) => {
      var textA = a.status.toUpperCase()
      var textB = b.status.toUpperCase()
      return ( textA < textB ) ? -1 : ( textA > textB ) ? 1 : 0
    } )
  }

  reset = () => this.setState( {
    debtorsInfo: this.state.request.debtorsInfo,
  } )

  updateMainDebtor = () => {
    const { debtorsInfo } = this.state
    updateDebt( this.props.auth.token, { id: this.props.getDebt.id, idDebtor: debtorsInfo.idDebtor } )
      .then( () => toastr.success( strings.generalStrings.mainDebtorSaved ) )
      .catch( () => toastr.error( strings.generalStrings.errorSavingMainDebtor ) )
    this.setState( {
      request: {
        debtorsInfo: {
          ...debtorsInfo,
          idDebtor: debtorsInfo.idDebtor,
        },
      },
    } )
  }

  save = () => {
    // const emailValidation = /^.+@.+$/
    // let validEmails = true                         Left this commented for future use
    const { request, debtorsInfo } = this.state
    if ( !_.isEqual( request.debtorsInfo, debtorsInfo ) ) {
      if ( !_.isEqual( request.debtorsInfo.idDebtor, debtorsInfo.idDebtor ) ) {
        this.updateMainDebtor()
      }
      if ( this.state.debtorsToDelete.length !== 0 ) {
        this.deleteDebtDebtors()
      }
      this.updateDebtDebtors()
    }
  }

  deleteDebtDebtors = () => {
    this.state.debtorsToDelete.forEach( debtor => {
      if ( debtor.id ) {
        removeDebtor( this.props.auth.token, { id: debtor.id } )
      }
    } )
    const newRequestDebtDebtors = this.state.request.debtorsInfo.debtDebtors.filter( debtDebtor => {
      return _.find( this.state.debtorsToDelete, { "id": debtDebtor.debtor.id } ) === undefined
    } )
    this.setState( {
      request: {
        ...this.state.request,
        debtorsInfo: {
          ...this.state.request.debtorsInfo,
          debtDebtors: newRequestDebtDebtors,
        },
      },
      debtorsToDelete: [],
    } )
  }
  updateDebtDebtors = () => {
    const { request, debtorsInfo } = this.state

    debtorsInfo.debtDebtors
      .map( debtDebtor => debtDebtor.debtor )
      .filter( debtor => {
        const requestDebtor = request.debtorsInfo.debtDebtors
          .map( requestDebtDebtor => requestDebtDebtor.debtor )
          .find( requestDebtor => requestDebtor.id === debtor.id )

        return !_.isEqual( debtor, requestDebtor )
      } )
      .map( debtor => {
        const fn = ( debtor.id === undefined ) ? addDebtor : updateDebtorContact
        const addParams = ( debtor.id === undefined ) ? { debtId: this.props.getDebt.id } : {}
        return {
          actionFn: fn,
          debtor: { ...debtor, ...addParams },
        }
      } )
      .forEach( ( { actionFn, debtor } ) => {
        let newDebtor = removeNulls( debtor )
        newDebtor.contact = { ...removeNulls( debtor.contact ) }
        return actionFn( this.props.auth.token, _.omit( newDebtor, [ "idContact" ] ) )
          .then( newDebtor => {
            toastr.success( strings.generalStrings.changesSaved )
            const isAdd = debtor.id === undefined
            this.updateDebtorsInfoAndRequest( {
              debtDebtors: this.state.debtorsInfo.debtDebtors
                .map( debtDebtor => {
                  if (
                    debtDebtor.idDebtor === newDebtor.result.id ||
                    ( isAdd && debtDebtor.debtor.id === undefined )
                  ) {
                    return {
                      ...debtDebtor,
                      debtor: newDebtor.result,
                    }
                  }
                  return debtDebtor
                } ),
            } )
          } ).catch( () => toastr.error( strings.generalStrings.errorSaving ) )
      } )
  }

  updateDebtorsInfoAndRequest = newData => {
    const newDebtorsInfo = {
      ...this.state.debtorsInfo,
      ...newData,
    }

    this.setState( {
      request: {
        ...this.state.request,
        debtorsInfo: newDebtorsInfo,
      },
      debtorsInfo: newDebtorsInfo,
    } )
  }

  fetchDebtors = debtId => getDebtDebtors( this.props.auth.token, debtId )
    .then( response => {
      const debtorsInfo = ( response.message !== "OK" ) ? null : response.result
      this.setState( {
        request: {
          ...this.state.request,
          debtorsInfo,
        },
        debtorsInfo,
      } )
    } )

  renderDebtors = () => {
    const debtorsInfo = this.state.debtorsInfo || {}
    if ( _.isEqual( debtorsInfo, {} ) ) {
      return <div />
    }
    return (
      <DebtPhaseDebtors
        debtId={this.props.getDebt.id}
        mainDebtorId={debtorsInfo.idDebtor}
        debtors={( debtorsInfo.debtDebtors || [] ).map( debtDebtor => debtDebtor.debtor )}
        upperState={this.state}
        onChange={( newDebtors ) => {
          const safeDebtDebtors = ( this.state.debtorsInfo.debtDebtors || [] )

          const newDebtDebtors = newDebtors.map( newDebtor => {
            const debtDebtor = safeDebtDebtors.find( debtDebtor => debtDebtor.idDebtor === newDebtor.id )
            const defaultDebtDebtor = { debtId: this.props.getDebt.id }
            return {
              ...( debtDebtor || defaultDebtDebtor ),
              debtor: newDebtor,
            }
          } )
          this.setState( {
            debtorsInfo: {
              ...this.state.debtorsInfo,
              debtDebtors: newDebtDebtors,
            },
          } )
        }}
        onChangeMainDebtor={debtorId => {
          this.setState( {
            debtorsInfo: {
              ...this.state.debtorsInfo,
              idDebtor: debtorId,
            },
          } )
        }}
        changeRepresentantOrGuarantor={( debtorId, booleanToChange ) => {
          const newDebtDebtors = this.state.debtorsInfo.debtDebtors.map( debtDebtor => ( {
            ...debtDebtor,
            debtor: {
              ...debtDebtor.debtor,
              [ booleanToChange ]: _.isEqual( debtorId, debtDebtor.debtor.id ) ? true : false,
            },
          } ) )
          return this.setState( {
            debtorsInfo: {
              ...this.state.debtorsInfo,
              debtDebtors: newDebtDebtors,
            },
          } )
        }}
        onDelete={debtor => {
          const newDebtDebtors = this.state.debtorsInfo.debtDebtors
            .filter( debtDebtor => debtDebtor.debtor.id !== debtor.id )
          return this.setState( {
            debtorsInfo: {
              ...this.state.debtorsInfo,
              debtDebtors: newDebtDebtors,
            },
            debtorsToDelete: [ ...this.state.debtorsToDelete, debtor ],
          } )
        }}
        expanded={false}
      />
    )
  }

  renderContactHistory = () => {
    return (
      <DebtPhaseContactHistory
        removeContactHistory={async ( id ) => {
          await this.props.removeContactHistory( id )
          this.setState( {
            contactHistories: this.state.contactHistories
              .filter( ch => ch.id !== id ),
          } )
        }}
        newContactHistory={async ( newContactHistory ) => {
          const completeContactHistory = {
            ...newContactHistory,
            idDebt: this.props.getDebt.id,
          }
          await this.props.newContact( completeContactHistory )

          const response = await getContactHistorybyDebtId( this.props.auth.token, parseInt( this.props.match.params.debtId ) )

          this.setState( {
            contactHistories: response.result,
          } )

        }}
        updateContactHistory={async ( updatedContactHistory ) => {
          await updateContactHistory( this.props.auth.token, updatedContactHistory )

          const response = await getContactHistorybyDebtId( this.props.auth.token, parseInt( this.props.match.params.debtId ) )

          this.setState( {
            contactHistories: response.result,
          } )

        }}
        contactHistories={this.state.contactHistories}
        expanded={false}
      />
    )
  }

  render () {
    const debtorsInfo = this.state.debtorsInfo || {}

    const debtorsNumber = ( this.props.getDebt.debtors || [] ).length
    const paymentAgreementNumber = ( this.props.getDebt.paymentAgreements || [] ).length
    const contactHistoryNumber = ( this.props.getDebt.contactHistories || [] ).length
    const preLitNumber = ( this.props.getDebt.preLitigations || [] ).length
    const litNumber = ( this.props.getDebt.litigations || [] ).length
    const execNumber = ( this.props.getDebt.executions || [] ).length

    const carteira = _.chain(this.props.getDebt)
      .get("preLitigations", [])
      .map(pl => pl.lot.externalReference)
      .uniq()
      .join(" / ")
      .value();

    if ( _.isEqual( debtorsInfo, {} ) ) {
      return <div />
    }
    return (
      <div className="debtContainer">
        <DebtSummaryHeader
          title={strings.generalStrings.debt}
          debt={this.props.getDebt}
          isProcessPhase={false}
          carteira={carteira}
        />
        {this.renderTab( this.renderDebtors, strings.debtor.debtors, this.showDebtors, this.state.showDebtors, debtorsNumber )}
        {this.renderTab( this.renderPaymentAgreements, strings.paymentAgreements.paymentAgreementsTitle.toUpperCase(), this.showPaymentAgreements, this.state.showPaymentAgreements, paymentAgreementNumber )}
        {this.renderTab( this.renderContactHistory, strings.contactHistory.contactHistory, this.showContactHistory, this.state.showContactHistory, contactHistoryNumber )}
        {this.renderTab( this.renderPreLitigation, strings.processes.preLitigation.toUpperCase(), this.showPreLitigation, this.state.showPreLitigation, preLitNumber )}
        {this.renderTab( this.renderLitigation, strings.processes.litigation.toUpperCase(), this.showLitigation, this.state.showLitigation, litNumber )}
        {this.renderTab( this.renderExecution, strings.processes.execution.toUpperCase(), this.showExecution, this.state.showExecution, execNumber )}
        <SaveButton
          onSave={this.save}
          onCancel={this.reset}
          show={
            !_.isEqual( this.state.request.debtorsInfo, this.state.debtorsInfo )
          }
        />
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
    getDebt: store.getDebt,
  }
}

export default connect( mapStateToProps, {
  getDebtById,
  updateDebtorContact,
  addDebtor,
  newContact,
  removeContactHistory,
} )( withRouter( DebtView ) )



// WEBPACK FOOTER //
// ./src/views/DebtView/index.jsx